import {
  MenuItem,
  Container,
  Select,
  TextField,
  InputLabel,
  FormControl,
  InputAdornment,
} from "@mui/material";
import NavigationPage from "../../../ui/templates/NavigationPage";
import { getMandatoryCourses } from "../api/getMandatoryCourses";
import _cookies from "../../../shared/utils/_cookies";
import MandatoryAndRecommendedCourses from "../components/MandatoryAndRecommendedCourses";
import { useState } from "react";
import { Search } from "@mui/icons-material";
import { useLocation, useSearchParams } from "react-router-dom";

const ObrigatoriosPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const ids = searchParams.get("ids")?.split(",") || [];
  const [filters, setFilters] = useState("Todos");
  const [search, setSearch] = useState();

  const onChangeFilter = (e) => {
    setFilters((prev) => e.target.value);
  };
  const onChangeSearch = (e) => {
    setSearch((prev) => e.target.value);
  };

  return (
    <NavigationPage
      rootRoute={{
        label: "Cursos obrigatórios",
        route: "/obrigatorios" + location.search,
      }}
      actions={
        <span className="flex flex-row gap-2">
          <TextField
            label="Procurar"
            value={search}
            onChange={onChangeSearch}
            variant="standard"
            placeholder="Procurar nome do curso"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          <FormControl>
            <InputLabel variant="standard" className="text-sm">
              Filtrar cursos
            </InputLabel>
            <Select
              label={<>Filtrar por</>}
              value={filters}
              onChange={onChangeFilter}
              variant="standard"
            >
              <MenuItem value="Todos">Todos cursos</MenuItem>
              <MenuItem value="Em andamento">Em andamento</MenuItem>
              <MenuItem value="Concluídos">Concluídos</MenuItem>
              <MenuItem value="Expirados">Expirados</MenuItem>
              <MenuItem value="Sem matrícula">Sem matrícula</MenuItem>
            </Select>
          </FormControl>
        </span>
      }
    >
      <Container sx={{ position: "relative", height: "100%" }} maxWidth={false}>
        <div className="relative h-full w-full">
          <MandatoryAndRecommendedCourses
            filters={{ ids, search, status: filters }}
            queryFn={() =>
              getMandatoryCourses({
                studentId: _cookies.getItem("auth").user.alunoid,
              })
            }
            queryKey={[
              "mandatoryCourses",
              { studentId: _cookies.getItem("auth").user.alunoid },
            ]}
          />
        </div>
      </Container>
    </NavigationPage>
  );
};

export default ObrigatoriosPage;
